import { useQuery } from "@apollo/client";
import { Spinner } from "@blueprintjs/core";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import sortBy from "lodash/sortBy";

import { Flex } from "@/components/layout/flexbox";
import { FaqDocument } from "@/graphql";

import FaqItems from "./FaqItems";

export default function FaqCategory({ category, preOpen = false }) {
  const { data } = useQuery(FaqDocument, {
    fetchPolicy: "cache-first",
    variables: {
      category: category,
    },
  });

  if (!data || !data.faq) {
    return (
      <Flex justifyContent="center">
        <Spinner size={34} />
      </Flex>
    );
  }
  if (!data.faq.questions || !data.faq.questions.length) {
    return null;
  }

  const questions = sortBy(data.faq.questions, (q) => q.order);
  const faqItems = questions.map((question) => {
    return {
      question: question.question,
      answer: documentToHtmlString(JSON.parse(question.answer)),
    };
  });
  return <FaqItems faqItems={faqItems} preOpen={preOpen} />;
}
